import Cookies from 'js-cookie';
import actions from './actions';
import { DataService } from '../../config/dataService/dataService';
import { setItem } from '../../utility/localStorageControl';

const { loginBegin, loginSuccess, loginErr, logoutBegin, logoutSuccess, logoutErr } = actions;

const loadPermissions = async (roleId) => {
  try {
    const response = await DataService.get(`/roles/${roleId}/permissions`);
    if (response?.status === 200) {
      localStorage.setItem('permissions', JSON.stringify(response?.data?.data));
    }
  } catch (error) {
    console.error('Error loading permissions:', error);
  }
};

const login = (values, callback) => {
  return async (dispatch) => {
    dispatch(loginBegin());
    try {
      // const response = await DataService.post('/users/login', values);
      const response = await DataService.post('/users/verify-otp', values);
      if (response.data && response.data.status === 200) {
        setItem('access_token', response?.data?.data?.token);
        setItem('logedIn', true);
        setItem('roleId', response?.data?.data?.roleId);
        await loadPermissions(response?.data?.data?.roleId);
        setItem('displayName', response?.data?.data?.displayName);
        dispatch(loginSuccess(true));
        callback(response?.data?.data?.roleId);
      }
      dispatch(loginErr(response.data.data.message));
    } catch (err) {
      dispatch(loginErr(err));
    }
  };
};

const register = (values) => {
  return async (dispatch) => {
    dispatch(loginBegin());
    try {
      const response = await DataService.post('/register', values);
      if (response.data.errors) {
        dispatch(loginErr('Registration failed!'));
      } else {
        dispatch(loginSuccess(false));
      }
    } catch (err) {
      dispatch(loginErr(err));
    }
  };
};

const logOut = (callback) => {
  return async (dispatch) => {
    dispatch(logoutBegin());
    try {
      Cookies.remove('logedIn');
      Cookies.remove('access_token');
      dispatch(logoutSuccess(false));
      callback();
    } catch (err) {
      dispatch(logoutErr(err));
    }
  };
};

export { login, logOut, register };
